import { useSelector } from "react-redux";
import ProductCard from "../ProductCard";
import "./index.scss";
import ProductItem from "../ProductItem";
const ProductGrid = () => {
  // Example product data, you might fetch this from an API or other source in a real app

  const productsRecentlyViewed = useSelector(
    (state: Storage) => state?.entities?.recentlyViewedSlice?.product,
  );

  return (
    <>
      {productsRecentlyViewed?.length > 0 ? (
        productsRecentlyViewed.map((product : any , index : any) => (
          <ProductItem key={index} product={product} type={"product"} />
        ))
      ) : (
        <></>
      )}
    </>
  );
};

export default ProductGrid;
